function autoRootFontSize() {
  //(当前屏幕宽度，最小宽度为1200)/1920*16px
  let setSize = Math.max(document.documentElement.getBoundingClientRect().width,800) / 1920 * 25;  
  //字体默认最大值为16px
  document.documentElement.style.fontSize = (setSize > 15 ? 15 : setSize) + 'px';
}
window.addEventListener('resize', autoRootFontSize);
autoRootFontSize();